// import React, { Component } from "react";
// import { Card } from "primereact/card";
// import { Dropdown } from "primereact/dropdown";
// import { MultiSelect } from "primereact/multiselect";
// import { InputText } from "primereact/inputtext";
// import { InputTextarea } from "primereact/inputtextarea";
// import { InputNumber } from "primereact/inputnumber";
// import { Button } from "primereact/button";

// class OrderInfo extends Component {
//     constructor(props) {
//         super(props);

//         this.state = {
//             orderType: "Dine In",
//             section: null,
//             source: null,
//             staff: null,
//             tableNos: [],
//             noOfCovers: null,
//             customerGST: "",
//             orderRemark: ""
//         };
//     }

//     sectionOptions = [
//         { label: "Dine In", value: "Dine In" },
//         { label: "AC Hall", value: "AC Hall" },
//         { label: "Family Hall", value: "Family Hall" }
//     ];

//     sourceOptions = [
//         { label: "NA", value: "NA" },
//         { label: "Online", value: "Online" },
//         { label: "Phone", value: "Phone" }
//     ];

//     staffOptions = [
//         { label: "NA", value: "NA" },
//         { label: "Staff 1", value: "Staff 1" },
//         { label: "Staff 2", value: "Staff 2" }
//     ];

//     tableOptions = [
//         { label: "Table 1", value: 1 },
//         { label: "Table 2", value: 2 },
//         { label: "Table 3", value: 3 },
//         { label: "Table 4", value: 4 },
//         { label: "Table 5", value: 5 }
//     ];

//     resetForm = () => {
//         this.setState({
//             section: null,
//             source: null,
//             staff: null,
//             tableNos: [],
//             noOfCovers: null,
//             customerGST: "",
//             orderRemark: ""
//         });
//     };

//     finishOrder = () => {
//         console.log(this.state);
//     };

//     render() {
//         return (
//             <div className="p-4">
//                 <Card>
//                     <div className="p-4">
//                         <h2
//                             style={{
//                                 marginBottom: "24px",
//                                 color: "#0B6B8A",
//                                 fontWeight: "500",
//                                 fontSize: "1.8rem"
//                             }}
//                         >
//                             Order Info
//                         </h2>

//                         {/* Order Type Buttons */}
//                         <div className="flex justify-content-start gap-3 mb-4">
//                             <Button
//                                 label="Dine In"
//                                 outlined={this.state.orderType !== "Dine In"}
//                                 onClick={() =>
//                                     this.setState({ orderType: "Dine In" })
//                                 }
//                                 style={{ minWidth: "120px" }}
//                             />

//                             <Button
//                                 label="Take Away"
//                                 outlined={this.state.orderType !== "Take Away"}
//                                 onClick={() =>
//                                     this.setState({ orderType: "Take Away" })
//                                 }
//                                 style={{ minWidth: "120px" }}
//                             />

//                             <Button
//                                 label="Delivery"
//                                 outlined={this.state.orderType !== "Delivery"}
//                                 onClick={() =>
//                                     this.setState({ orderType: "Delivery" })
//                                 }
//                                 style={{ minWidth: "120px" }}
//                             />
//                         </div>

//                         <div className="grid mt-3" style={{ rowGap: "20px" }}>
//                             {/* Section - Left Column */}
//                             <div className="col-12 md:col-6">
//                                 <label className="font-semibold" style={{ display: "block", marginBottom: "8px" }}>
//                                     Section
//                                 </label>
//                                 <Dropdown
//                                     value={this.state.section}
//                                     options={this.sectionOptions}
//                                     onChange={(e) =>
//                                         this.setState({
//                                             section: e.value
//                                         })
//                                     }
//                                     placeholder="Select Section"
//                                     className="w-full"
//                                 />
//                             </div>

//                             {/* Table No - Right Column */}
//                             <div className="col-12 md:col-6">
//                                 <label className="font-semibold" style={{ display: "block", marginBottom: "8px" }}>
//                                     Table No
//                                 </label>
//                                 <MultiSelect
//                                     value={this.state.tableNos}
//                                     options={this.tableOptions}
//                                     onChange={(e) =>
//                                         this.setState({
//                                             tableNos: e.value
//                                         })
//                                     }
//                                     display="chip"
//                                     placeholder="Select Table No"
//                                     className="w-full"
//                                 />
//                             </div>

//                             {/* Source - Left Column */}
//                             <div className="col-12 md:col-6">
//                                 <label className="font-semibold" style={{ display: "block", marginBottom: "8px" }}>
//                                     Source
//                                 </label>
//                                 <Dropdown
//                                     value={this.state.source}
//                                     options={this.sourceOptions}
//                                     onChange={(e) =>
//                                         this.setState({
//                                             source: e.value
//                                         })
//                                     }
//                                     placeholder="Select Source"
//                                     className="w-full"
//                                 />
//                             </div>

//                             {/* Staff - Right Column */}
//                             <div className="col-12 md:col-6">
//                                 <label className="font-semibold" style={{ display: "block", marginBottom: "8px" }}>
//                                     Staff
//                                 </label>
//                                 <Dropdown
//                                     value={this.state.staff}
//                                     options={this.staffOptions}
//                                     onChange={(e) =>
//                                         this.setState({
//                                             staff: e.value
//                                         })
//                                     }
//                                     placeholder="Select Staff"
//                                     className="w-full"
//                                 />
//                             </div>

//                             {/* No Of Covers - Left Column */}
//                             <div className="col-12 md:col-6">
//                                 <label className="font-semibold" style={{ display: "block", marginBottom: "8px" }}>
//                                     No Of Covers
//                                 </label>
//                                 <InputNumber
//                                     value={this.state.noOfCovers}
//                                     onValueChange={(e) =>
//                                         this.setState({
//                                             noOfCovers: e.value
//                                         })
//                                     }
//                                     className="w-full"
//                                     min={1}
//                                     max={20}
//                                     placeholder="Enter number"
//                                 />
//                             </div>

//                             {/* Customer GST - Right Column */}
//                             <div className="col-12 md:col-6">
//                                 <label className="font-semibold" style={{ display: "block", marginBottom: "8px" }}>
//                                     Customer GST No.
//                                 </label>
//                                 <InputText
//                                     value={this.state.customerGST}
//                                     onChange={(e) =>
//                                         this.setState({
//                                             customerGST: e.target.value
//                                         })
//                                     }
//                                     className="w-full"
//                                     placeholder="Enter GST Number"
//                                 />
//                             </div>

//                             {/* Order Remark - Full Width */}
//                             <div className="col-12">
//                                 <label className="font-semibold" style={{ display: "block", marginBottom: "8px" }}>
//                                     Order Remark
//                                 </label>
//                                 <InputTextarea
//                                     rows={4}
//                                     value={this.state.orderRemark}
//                                     onChange={(e) =>
//                                         this.setState({
//                                             orderRemark: e.target.value
//                                         })
//                                     }
//                                     className="w-full"
//                                     placeholder="Enter any special instructions or remarks..."
//                                 />
//                             </div>

//                             {/* Buttons - Right Aligned */}
//                             <div className="col-12">
//                                 <div
//                                     className="flex justify-content-end gap-3 mt-4 pt-3"
//                                     style={{ borderTop: "1px solid #e0e0e0" }}
//                                 >
//                                     <Button
//                                         label="Cancel"
//                                         icon="pi pi-times"
//                                         severity="danger"
//                                         outlined
//                                         onClick={this.resetForm}
//                                     />

//                                     <Button
//                                         label="Finish"
//                                         icon="pi pi-check"
//                                         severity="success"
//                                         onClick={this.finishOrder}
//                                     />
//                                 </div>
//                             </div>
//                         </div>
//                     </div>
//                 </Card>
//             </div>
//         );
//     }
// }

// export default OrderInfo;


import React, { Component } from 'react';
import { InputText } from 'primereact/inputtext';
import { connect } from 'react-redux';
import { Dropdown } from 'primereact/dropdown';
import { InputSwitch } from 'primereact/inputswitch';
import { Toast } from 'primereact/toast';
import { MultiSelect } from 'primereact/multiselect';
import { Calendar } from 'primereact/calendar';
import { Button } from 'primereact/button';
import Messages from '../../../shared/UI/Messages/Messages';
import axios from '../../../axios-url';


import { REDIRECT_TO_URL, HASACCESS } from '../../../shared/utility';
import { DROPDOWN_CONFIG, USER_SUBMENU_ID } from '../../../shared/Config';
import FooterButton from '../../../shared/UI/FooterButton/FooterButton';
import * as actions from '../../../store/actions/index';

class OrderInfo extends Component {
    state = {
        roles: [],
        type: 'add',
        Id: null,
        UserId: null,
        EmployeeId: null,
        RoleId: null,
        functionalRoleId: [],
        functionalRoleOptions: [],
        approvalroles: [],
        approvalRoleId: null,
        UserId1: '',
        FirstName: '',
        MiddleName: '',
        LastName: '',
        EmailId: '',
        Password: '',
        MobileNumber: '',
        Activedirectory: false,
        Adloginid: '',
        Disablelogin: false,
        IsActive: false,
        createdBy: (this.props.loggedUserDetail.userName) ?? 'Admin',
        createdDate: new Date(),
        CompanyId: this.props.loggedUserDetail.CompanyId,
        touch: false
    }

    componentDidMount() {
        this.getAccess = HASACCESS(USER_SUBMENU_ID);
        let id = this.props.match.params.id;
        this.props.getMasterTableList('GeUsers?id=' + id);
        this.props.getMasterKeywordList('Role');
        this.props.getMasterKeywordList('Employee');
        this.props.getMasterKeywordList('ApprovalRole');
        let type = this.props.match.params.type;

        axios.get('/master/api/DropDownValues/FRole')
            .then(response => {
                if (response.status === 200) {
                    let data = []
                    if (response.data && response.data.length > 0) {
                        data = response.data.map(list => {
                            let value = list.id;
                            let id = list.id;
                            let text = list.text
                            return { label: text, value: value.toString(), id: id };
                        })
                    }
                    this.setState({ functionalRoleOptions: data })
                }
            }
            )
            .catch(err => {
                this.growl.show({ severity: 'error', summary: null, detail: 'Functional Roles Api Failed' });
            })

        if (type !== 'add') {
            this.timer();
        }
    }

    timer = () => {
        this.intervalID = setInterval(() => {
            this.fetchSingleProcess();
        }, 2000)
    }
    componentWillUnmount() {
        if (this.props.tableLists.usersList !== undefined) {
            clearInterval(this.intervalID);
        }
    }

    fetchSingleProcess = () => {

        let id = this.props.match.params.id;
        let type = this.props.match.params.type;
        let storageItems = [];
        if (this.props.tableLists.usersList !== undefined) {
            storageItems = this.props.tableLists.users;
            clearInterval(this.intervalID);
        }
        if (storageItems) {
            let filterData = storageItems;
            if (filterData) {
                let roles = '';
                let functionalRoles = '';
                let approvalroles = '';
                if (filterData.roleAssigned != null) {
                    roles = filterData.roleAssigned.split(",")
                }
                if (filterData.functionalRole != null) {
                    functionalRoles = filterData.functionalRole.split(",")
                }
                if (filterData.approvalrole != null) {
                    approvalroles = filterData.approvalrole.split(",")
                }
                var data = {
                    type: type,
                    Id: filterData.id,
                    UserId: filterData.userId,
                    EmployeeId: filterData.employeeId,
                    RoleId: roles,
                    approvalRoleId: approvalroles,
                    UserId1: filterData.userid1,
                    FirstName: filterData.firstName,
                    functionalRoleId: functionalRoles,
                    MiddleName: filterData.middleName,
                    LastName: filterData.lastName,
                    EmailId: filterData.emailId,
                    Password: filterData.password,
                    MobileNumber: filterData.mobileNumber,
                    Activedirectory: filterData.activedirectory,
                    Adloginid: filterData.adloginid,
                    Disablelogin: filterData.disablelogin,
                    IsActive: filterData.isActive,
                    CreatedBy: filterData.createdby,
                    CreatedDate: filterData.createddate,
                }
                this.setState(data);

            }
        }

    }


    change = (e) => {
        let { name, value } = e.target;
        this.setState({ [name]: value, touch: true })

    }

    add = () => {

        if (this.state.EmployeeId === null) {
            this.growl.show({ severity: 'error', summary: null, detail: 'Employee is required' });
            return;
        } else if (this.state.RoleId === null || this.state.RoleId === '') {
            this.growl.show({ severity: 'error', summary: null, detail: 'Role is required' });
            return;
        }

        else if (this.state.UserId1 === "") {
            this.growl.show({ severity: 'error', summary: null, detail: 'UserName is required' });
            return;
        } else if (this.state.FirstName === "") {
            this.growl.show({ severity: 'error', summary: null, detail: 'FirstName is required' });
            return;
        } else if (this.state.LastName === "") {
            this.growl.show({ severity: 'error', summary: null, detail: 'LastName is required' });
            return;
        } else if (this.state.EmailId === "" || this.state.EmailId === null) {
            this.growl.show({ severity: 'error', summary: null, detail: 'EmailId is required' });
            return;
        } else if (this.state.Password === "") {
            this.growl.show({ severity: 'error', summary: null, detail: 'Password is required' });
            return;
        } else if (this.state.MobileNumber === "" || this.state.MobileNumber === null) {
            this.growl.show({ severity: 'error', summary: null, detail: 'MobileNumber is required' });
            return;
        } else if (this.state.approvalRoleId === "" || this.state.approvalRoleId === null) {
            this.growl.show({ severity: 'error', summary: null, detail: 'Approval Roleid is required' });
            return;
        } else if (this.state.functionalRoleId === "" || this.state.functionalRoleId === null) {
            this.growl.show({ severity: 'error', summary: null, detail: 'functional Roleid is required' });
            return;
        }
        var data = {
            EmployeeId: this.state.EmployeeId,
            RoleId: null,
            UserId1: this.state.UserId1,
            FirstName: this.state.FirstName,
            FunctionalRole: this.state.functionalRoleId.join(),
            Approvalrole: this.state.approvalRoleId.join(),
            MiddleName: this.state.MiddleName,
            LastName: this.state.LastName,
            EmailId: this.state.EmailId,
            Password: this.state.Password,
            MobileNumber: this.state.MobileNumber,
            RoleAssigned: this.state.RoleId.join(),
            Activedirectory: this.state.Activedirectory,
            Adloginid: this.state.Adloginid,
            Disablelogin: this.state.Disablelogin,
            IsActive: this.state.IsActive,
            CompanyId: this.state.CompanyId,
            CreatedBy: this.state.createdBy,
            CreatedDate: this.state.createdDate,
        }


        if (this.state.type === 'edit') {
            data.UserId = this.state.UserId;
            data.Id = this.state.Id
        }

        this.props.processDynamicData('user', this.state.type, data, 'GeUsers');

    }

    resetData = () => {
        var data = {
            UserId: null,
            EmployeeId: null,
            RoleId: null,
            functionalRoleId: null,
            approvalRoleId: null,
            UserId1: '',
            FirstName: '',
            MiddleName: '',
            LastName: '',
            EmailId: '',
            Password: '',
            MobileNumber: '',
            Activedirectory: false,
            Disablelogin: false,
            IsActive: false,
            type: 'add'
        }
        this.setState(data);
    }

    render() {
        if (this.props.success) {
            REDIRECT_TO_URL('/users/', this.props);
        }


        let addAccess = true;
        let editAccess = true;
        if (this.getAccess !== undefined) {
            if (this.getAccess.viewAccess === false && this.props.userDetail.userId !== this.props.match.params.id) { this.props.history.push('/dashboard') }
            addAccess = (this.getAccess.addAccess === true) ? true : false;
            editAccess = (this.getAccess.editAccess === true) ? true : false;
        }
        let accessButton = { addAccess: addAccess, editAccess: editAccess }

        let roleOptions = [];
        if (this.props.Role && this.props.Role.length > 0) {
            roleOptions = this.props.Role;
        }
        let approvalroleOptions = [];
        if (this.props.ApprovalRole && this.props.ApprovalRole.length > 0) {
            approvalroleOptions = this.props.ApprovalRole;
        }

        let isEnabled = (this.state.touch === true);

        let redirectURL = '/users/';
        if (this.props.userDetail && this.props.match.params.id !== undefined) {
            if (this.props.userDetail.userId === this.props.match.params.id) {
                redirectURL = "/dashboard";
            }
        }

        const { name, label, value, placeholder, metaData, onInputChange, noLabel, disabled } = this.props;

        // Ensure value is always an array for MultiSelect
        let arrayValue = [];
        if (Array.isArray(value)) {
            arrayValue = value;
        } else if (typeof value === 'string' && value) {
            arrayValue = value.split(',').map(v => v.trim()).filter(v => v);
        }

        return (
            <div className="p-grid">
                {this.props.loading && <div className="page-loader"></div>}
                {this.props.error !== null && <Messages type="error" message={this.props.error} />}
                {this.props.success !== null && <Messages type="success" message={this.props.success} />}
                <Toast ref={(el) => this.growl = el} />
                <div className="p-col-12">
                    <div className="card card-w-title" style={{ position: 'relative' }}>
                        <h1 style={{ marginBottom: '20px' }}>Order Information</h1>

                        <div className="p-grid p-nogutter" style={{ rowGap: '20px' }}>

                            {/* Row 1: Section | Table Number */}
                            <div className="p-col-12 p-md-6" style={{ paddingRight: '15px' }}>
                                <label htmlFor="section" style={{ display: 'block', marginBottom: '8px', fontWeight: '600' }}>
                                    Section <span style={{ color: 'red' }}>*</span>
                                </label>
                                <Dropdown
                                    className="w-full"
                                    style={{ height: '40px', width: '100%' }}
                                    placeholder="Select Section"
                                    options={this.props.GetEmployeedropdown}
                                    value={this.state.EmployeeId}
                                    name="EmployeeId"
                                    onChange={this.change}
                                    {...DROPDOWN_CONFIG}
                                />
                            </div>

                            <div className="p-col-12 p-md-6" style={{ paddingLeft: '15px' }}>
                                <label style={{ display: 'block', marginBottom: '8px', fontWeight: '600' }}>
                                    Table No
                                </label>
                                <MultiSelect
                                    disabled={disabled}
                                    name={name}
                                    placeholder="Select Table No"
                                    value={arrayValue}
                                    options={metaData && metaData[label] && Array.isArray(metaData[label]) && metaData[label] || []}
                                    onChange={onInputChange}
                                    filter={true}
                                    className="w-full"
                                    style={{ height: '40px', width: '100%' }}
                                    {...DROPDOWN_CONFIG}
                                />
                            </div>

                            {/* Row 2: Source | Staff */}
                            <div className="p-col-12 p-md-6" style={{ paddingRight: '15px' }}>
                                <label htmlFor="source" style={{ display: 'block', marginBottom: '8px', fontWeight: '600' }}>
                                    Source <span style={{ color: 'red' }}>*</span>
                                </label>
                                <Dropdown
                                    className="w-full"
                                    style={{ height: '40px', width: '100%' }}
                                    placeholder="Select Source"
                                    options={this.props.GetEmployeedropdown}
                                    value={this.state.EmployeeId}
                                    name="EmployeeId"
                                    onChange={this.change}
                                    {...DROPDOWN_CONFIG}
                                />
                            </div>

                            <div className="p-col-12 p-md-6" style={{ paddingLeft: '15px' }}>
                                <label htmlFor="staff" style={{ display: 'block', marginBottom: '8px', fontWeight: '600' }}>
                                    Staff <span style={{ color: 'red' }}>*</span>
                                </label>
                                <Dropdown
                                    className="w-full"
                                    style={{ height: '40px', width: '100%' }}
                                    placeholder="Select Staff"
                                    options={this.props.GetEmployeedropdown}
                                    value={this.state.EmployeeId}
                                    name="EmployeeId"
                                    onChange={this.change}
                                    {...DROPDOWN_CONFIG}
                                />
                            </div>

                            {/* Row 3: No.Of Covers | Customer GST Number */}
                            <div className="p-col-12 p-md-6" style={{ paddingRight: '15px' }}>
                                <label htmlFor="covers" style={{ display: 'block', marginBottom: '8px', fontWeight: '600' }}>
                                    No. Of Covers <span style={{ color: 'red' }}>*</span>
                                </label>
                                <InputText
                                    className="w-full"
                                    style={{ height: '40px', width: '100%' }}
                                    name="Covers"
                                    placeholder="Enter number"
                                    value={this.state.UserId1}
                                    onChange={this.change}
                                />
                            </div>

                            <div className="p-col-12 p-md-6" style={{ paddingLeft: '15px' }}>
                                <label htmlFor="gst" style={{ display: 'block', marginBottom: '8px', fontWeight: '600' }}>
                                    Customer GST No. <span style={{ color: 'red' }}>*</span>
                                </label>
                                <InputText
                                    className="w-full"
                                    style={{ height: '40px', width: '100%' }}
                                    name="FirstName"
                                    placeholder="Enter GST Number"
                                    value={this.state.FirstName}
                                    onChange={this.change}
                                />
                            </div>

                            {/* Row 4: Order Remark - Full Width */}
                            <div className="p-col-12" style={{ marginTop: '10px' }}>
                                <label htmlFor="details" style={{ display: 'block', marginBottom: '8px', fontWeight: '600' }}>
                                    Order Remark
                                </label>
                                <textarea
                                    rows="4"
                                    name="details"
                                    id="details"
                                    placeholder="Enter any special instructions or remarks..."
                                    className="p-col-12 p-inputtext"
                                    autoComplete="off"
                                    style={{
                                        resize: 'vertical',
                                        width: '100%',
                                        height: '100px',
                                        padding: '10px',
                                        fontSize: '14px',
                                        borderRadius: '4px',
                                        border: '1px solid #ced4da'
                                    }}
                                ></textarea>
                            </div>

                            {/* Footer Buttons - Full Width */}
                            <div className="p-col-12" style={{ marginTop: '20px', borderTop: '1px solid #e0e0e0', paddingTop: '20px' }}>
                                <div style={{ display: 'flex', justifyContent: 'flex-end', gap: '10px' }}>
                                    <Button
                                        label="Cancel"
                                        icon="pi pi-times"
                                        onClick={this.resetData}
                                        className="p-button-primary"
                                        style={{
                                            height: '40px',
                                            backgroundColor: '#3F51B5',
                                            color: 'white',
                                            border: 'none',
                                            minWidth: '100px'
                                        }}
                                        onMouseEnter={(e) => {
                                            e.target.style.backgroundColor = '#303F9F';
                                        }}
                                        onMouseLeave={(e) => {
                                            e.target.style.backgroundColor = '#3F51B5';
                                        }}
                                    />
                                    <Button
                                        label="Finish"
                                        icon="pi pi-check"
                                        onClick={this.add}
                                        disabled={!isEnabled}
                                        className="p-button-primary"
                                        style={{
                                            height: '40px',
                                            backgroundColor: '#3F51B5',
                                            color: 'white',
                                            border: 'none',
                                            minWidth: '100px'
                                        }}
                                        onMouseEnter={(e) => {
                                            e.target.style.backgroundColor = '#303F9F';
                                        }}
                                        onMouseLeave={(e) => {
                                            e.target.style.backgroundColor = '#3F51B5';
                                        }}
                                    />
                                </div>
                            </div>

                        </div>

                    </div>
                </div>
            </div>
        );
    }
}


const mapStateToProps = state => {
    return {
        loggedUserDetail: state.auth.userObject,
        userDetail: state.auth.userDetail,
        userPref: state.auth.userPref,
        GetEmployeedropdown: (state.keyword.Employee !== undefined) ? state.keyword.Employee : [],
        loading: state.master.loading,
        error: state.master.error,
        success: state.master.success,
        Role: (state.keyword.Role !== undefined) ? state.keyword.Role : [],
        ApprovalRole: (state.keyword.ApprovalRole !== undefined) ? state.keyword.ApprovalRole : [],
        tableLists: state.master.tableLists
    }
}

const mapDispatchToProps = dispatch => {
    return {
        getMasterTableList: (table) => dispatch(actions.getMasterTableList(table)),
        getMasterKeywordList: (value) => dispatch(actions.getMasterKeywordList(value)),
        fetchRelavantLists: (value) => dispatch(actions.fetchRelavantLists(value)),
        processDynamicData: (model, type, data, func) => dispatch(actions.processDynamicData(model, type, data, func)),
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(OrderInfo);